import { NavLink } from "react-router-dom";
import { MENU_LIST, UNIV_MENU_LIST } from "../../../utils/config";
import styles from "./Sidebar.module.scss";
import { useAuth } from "../../../contexts/AuthContext";
import { AUTH_UNIVERSITY } from "../../../utils/config";

const Sidebar = () => {
  // ユーザー情報
  const { user } = useAuth();
  let menuList = MENU_LIST;
  // 権限確認
  if (user.authority == AUTH_UNIVERSITY) {
    menuList = UNIV_MENU_LIST;
  }
  return (
    <nav className={styles.sidebar}>
      <ul className={styles.sidenav}>
        {menuList.map((menu) => (
          <li className={styles.sidenav__item} key={menu.url}>
            <NavLink to={menu.url} className={styles.sidenav__link}>
              <span>{menu.title}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
export default Sidebar;
